import vehicleViews from './vehicleViews';
import numberOfDays from './numberOfDays';

const root = {
	vehicleViews,
	numberOfDays
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js